export type RegMessageVariants =
  | 'generic'
  | 'follow_athlete'
  | 'join_challenge'
  | 'join_club'
  | 'kudos_comment'
  | 'trial_sign_up';

// when we add `_v2` strings for the variants, we need to map the variants to the proper key
const getTextKey = (variant: RegMessageVariants) => {
  if (
    variant === 'follow_athlete' ||
    variant === 'join_club' ||
    variant === 'trial_sign_up'
  ) {
    return `${variant}_v2`;
  }
  return variant;
};

// Not all variants have a subtitle. Attempt to translate the subtitle text
// and if it can't be translated (`t` gives back the translation key),
// we'll know not to render the subtitle.
export const getTitleAndSubtitle = (
  t: (k: string, p?: Record<string, string | undefined>) => string,
  variant: RegMessageVariants,
  name?: string
) => {
  const textKey = getTextKey(variant);
  const title = t(
    `account_registration_page_ui.registration_message.${textKey}.title`,
    { name }
  );

  const translatedSubtitle = t(
    `account_registration_page_ui.registration_message.${textKey}.subtitle`
  );

  const subtitle = translatedSubtitle.includes('account_registration_page_ui')
    ? null
    : translatedSubtitle;

  return { title, subtitle };
};
